import { DocumentsList } from "./DocumentsList";

export default DocumentsList;
